import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { productsByCategory, heroImages, categories } from "../../data/productData";

const findProductInCategory = (categoryKey, productIdOrName) => {
  const cat = productsByCategory[categoryKey];
  if (!cat) return { product: null, all: [] };

  const allProducts = [];
  const normalize = (p) => ({
    id: p.id || encodeURIComponent((p.name || "").replace(/\s+/g, "_")),
    name: p.name || p,
    image: p.image || "/assets/productimages/placeholder.jpg",
    use: p.use || "",
    description: p.description || p.details || "",
    specifications: p.specifications || p.details || "",
    price: p.price || "Contact for quote",
    availability: p.availability || "In Stock",
  });

  const tryPush = (p) => {
    if (!p) return;
    allProducts.push(normalize(p));
  };

  const walk = (obj) => {
    if (!obj) return;
    if (Array.isArray(obj)) {
      obj.forEach((p) => tryPush(p));
      return;
    }

    if (obj.products && Array.isArray(obj.products)) {
      obj.products.forEach((p) => tryPush(p));
    }

    if (obj.options) {
      Object.values(obj.options).forEach((opt) => walk(opt));
    }

    if (obj.options && typeof obj.options === "object") {
      Object.values(obj.options).forEach((opt) => walk(opt));
    }
  };

  // iterate top-level keys
  Object.values(cat).forEach((entry) => walk(entry));

  const product = allProducts.find(
    (p) =>
      p.id === productIdOrName ||
      p.name === productIdOrName ||
      encodeURIComponent(p.name.replace(/\s+/g, "_")) === productIdOrName
  );

  return { product, all: allProducts };
};

// const RelatedGrid = ({ items, currentId, categoryKey }) => {
//   const related = items.filter((p) => p.id !== currentId).slice(0, 3);
//   if (!related || related.length === 0) return null;
//   return (
//     <div>
//       <h3 className="text-lg sm:text-xl font-semibold mb-4">Related Products</h3>
//       <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
//         {related.map((p) => (
//           <Link
//             key={p.id}
//             to={`/our-products/${categoryKey}/${p.id}`}
//             className="block bg-white rounded-lg shadow p-3 hover:shadow-lg">
//             <div className="h-32 sm:h-40 overflow-hidden rounded-md mb-2 sm:mb-3">
//               <img
//                 src={p.image}
//                 alt={p.name}
//                 className="w-full h-full object-cover"
//               />
//             </div>
//             <h4 className="font-medium text-gray-900 mb-1 text-sm">{p.name}</h4>
//             <p className="text-xs sm:text-sm text-gray-600">{p.use}</p>
//           </Link>
//         ))}
//       </div>
//     </div>
//   );
// };

// const RelatedGrid = ({ items, currentId, categoryKey, currentProduct }) => {
//   // 1. Safety Check
//   if (!items || !currentProduct) return null;

//   // 2. Define keywords to find "Real" related products
//   // We take the first two words of the current product name (e.g., "Fire Wall" or "Gypsum Board")
//   const nameParts = currentProduct.name ? currentProduct.name.split(' ').slice(0, 2) : [];
  
//   const sameType = items.filter((p) => {
//     if (p.id === currentId) return false;
    
//     // Check if the other product's name contains any of our main keywords
//     return nameParts.some(word => 
//       word.length > 2 && p.name.toLowerCase().includes(word.toLowerCase())
//     );
//   });

//   // 3. Get items from the broader category to fill the gaps if sameType is empty
//   const others = items.filter((p) => 
//     p.id !== currentId && !sameType.some(st => st.id === p.id)
//   );

//   // 4. Combine: Specific type first, then general category
//   const related = [...sameType, ...others].slice(0, 3);

//   if (related.length === 0) return null;

//   return (
//     <div className="mt-10 border-t pt-8">
//       <h3 className="text-xl font-bold text-gray-800 mb-6">Related Products</h3>
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//         {related.map((p) => (
//           <Link
//             key={p.id}
//             to={`/our-products/${categoryKey}/${p.id}`}
//             className="group bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-all"
//           >
//             <div className="h-44 overflow-hidden">
//               <img
//                 src={p.image}
//                 alt={p.name}
//                 className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
//               />
//             </div>
//             <div className="p-4">
//               <h4 className="font-bold text-gray-900 text-sm mb-1 group-hover:text-[#00A3A1]">{p.name}</h4>
//               <p className="text-xs text-gray-500 line-clamp-2">{p.use || "Professional Grade"}</p>
//             </div>
//           </Link>
//         ))}
//       </div>
//     </div>
//   );
// };

// 

// const RelatedGrid = ({ items, currentId, categoryKey, currentProduct }) => {
//   if (!items || !currentProduct) return null;

//   const name = currentProduct.name.toLowerCase().replace(/[–—−-]/g, ' ');
//   const words = name.split(' ').filter(w => w.length > 3);
  
//   const industryKeywords = ['gypsum', 'board', 'tile', 'paint', 'pipe', 'fan', 'hvac', 'door', 'cement', 'insulat', 'pump'];
//   const anchor = words.find(w => industryKeywords.includes(w)) || words[0];

//   const scoredItems = items
//     .filter(p => p.id !== currentId)
//     .map(p => {
//       const pName = p.name.toLowerCase();
//       const pUse = (p.use || "").toLowerCase();
//       const currentUse = (currentProduct.use || "").toLowerCase();
//       let score = 0;

//       if (currentUse && pUse === currentUse) score += 40;

//       if (pName.includes(anchor)) score += 20;

//       words.forEach(word => {
//         if (pName.includes(word)) score += 5;
//       });

//       return { ...p, score };
//     })
//     .sort((a, b) => b.score - a.score); 
//   const related = scoredItems.slice(0, 3);

//   if (related.length === 0) return null;

//   return (
//     <div className="mt-12 border-t border-gray-200 pt-10">
//       <div className="flex items-center justify-between mb-8">
//         <h3 className="text-xl font-bold text-gray-800">Related Products</h3>
//         <div className="h-1 w-24 bg-[#00A3A1] rounded"></div>
//       </div>
      
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//         {related.map((p) => (
//           <Link
//             key={p.id}
//             to={`/our-products/${categoryKey}/${p.id}`}
//             className="group flex flex-col bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300"
//           >
//             <div className="h-48 overflow-hidden bg-gray-50">
//               <img
//                 src={p.image}
//                 alt={p.name}
//                 className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
//               />
//             </div>
//             <div className="p-5 flex-grow">
//               <h4 className="font-bold text-gray-900 text-sm mb-2 group-hover:text-[#00A3A1]">
//                 {p.name}
//               </h4>
//               <p className="text-xs text-gray-500 line-clamp-2">{p.use}</p>
//             </div>
//           </Link>
//         ))}
//       </div>
//     </div>
//   );
// };

const RelatedGrid = ({ items, currentId, categoryKey, currentProduct }) => {
  if (!items || !currentProduct) return null;

  const scoredItems = items
    .filter(p => p.id !== currentId)
    .map(p => {
      let score = 0;
      
      if (p.use && currentProduct.use && p.use === currentProduct.use) {
        score += 100;
      }

      const currentWords = currentProduct.name.toLowerCase().split(' ');
      currentWords.forEach(word => {
        if (p.name.toLowerCase().includes(word) && word.length > 3) {
          score += 10;
        }
      });

      return { ...p, score };
    })
    .sort((a, b) => b.score - a.score); 

  const related = scoredItems.slice(0, 3);

  if (related.length === 0) return null;

  return (
    <div className="mt-12 border-t border-gray-200 pt-10">
      <h3 className="text-xl font-bold text-gray-800 mb-6">Related Products</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {related.map((p) => (
          <Link
            key={p.id}
            to={`/our-products/${categoryKey}/${p.id}`}
            className="group block bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-lg transition-all"
          >
            <div className="h-44 overflow-hidden bg-gray-50">
              <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-4">
              <h4 className="font-bold text-gray-900 text-sm mb-1 group-hover:text-[#00A3A1]">{p.name}</h4>
              <p className="text-xs text-gray-500 line-clamp-2">{p.use || "Professional Solution"}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

const ProductDetail = () => {
  const { category, productId } = useParams();
  const navigate = useNavigate();
  const { product, all } = findProductInCategory(category, productId || "");

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <h2 className="text-2xl font-bold mb-2">Product not found</h2>
          <p className="text-gray-600 mb-4">The product could not be located in the selected category.</p>
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 text-white rounded"
            style={{ backgroundColor: "var(--accent)" }}>
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-accent-vertical">
      <div className="max-w-6xl mx-auto px-4 py-8 md:py-10">
        {/* Breadcrumbs */}
        {(() => {
          const categoryMeta = categories.find((c) => c.link === category) || {};
          const niceCategoryName =
            categoryMeta.name ||
            category
              .split("_")
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
              .join(" ");

          return (
            <nav
              className="breadcrumbs mb-4"
              aria-label="Breadcrumb">
              <ol className="flex items-center">
                <li>
                  <Link
                    to="/"
                    className="hover:underline">
                    Home
                  </Link>
                </li>
                <li aria-hidden>
                  <svg
                    className="w-4 h-4 text-gray-400 mx-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </li>
                <li>
                  <Link
                    to="/our-products"
                    className="hover:underline">
                    Products
                  </Link>
                </li>
                <li aria-hidden>
                  <svg
                    className="w-4 h-4 text-gray-400 mx-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </li>
                <li>
                  <Link
                    to={`/our-products/${category}`}
                    className="crumb-current">
                    {niceCategoryName}
                  </Link>
                </li>
                <li aria-hidden>
                  <svg
                    className="w-4 h-4 text-gray-400 mx-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </li>
                <li className="crumb-current">{product.name}</li>
              </ol>
            </nav>
          );
        })()}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="p-3 sm:p-4">
              <div className="h-48 sm:h-64 md:h-96 overflow-hidden rounded">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="p-4 sm:p-6">
              <h1 className="text-2xl sm:text-3xl font-extrabold mb-2 sm:mb-3">{product.name}</h1>
              <p className="text-xs sm:text-sm text-gray-500 mb-4">{product.use}</p>

              <div className="mb-4">
                <h4 className="text-xs sm:text-sm font-semibold text-gray-700">Specifications</h4>
                <p className="text-xs sm:text-gray-800">{product.specifications || "N/A"}</p>
              </div>

              <div className="mb-4">
                <h4 className="text-xs sm:text-sm font-semibold text-gray-700">Description</h4>
                <p className="text-xs sm:text-gray-800 leading-relaxed">
                  {product.description || "No description available."}
                </p>
              </div>

              {/* <div className="grid grid-cols-2 gap-2 sm:gap-4 mb-6">
                <div className="bg-accent-50 p-2 sm:p-3 rounded">
                  <h5 className="text-xs font-semibold text-accent-dark">Price</h5>
                  <p className="text-xs sm:text-sm font-medium">{product.price}</p>
                </div>
                <div className="bg-green-50 p-2 sm:p-3 rounded">
                  <h5 className="text-xs text-green-700 font-semibold">Availability</h5>
                  <p className="text-xs sm:text-sm font-medium">{product.availability}</p>
                </div>
              </div> */}
               
               <div className="grid grid-cols-2 gap-2 sm:gap-4 mb-6 items-stretch">
  {/* 1. The Button (Now inside the grid, replacing the Price box) */}
  <Link 
    to="/contact-us" 
    className="bg-[#00A3A1] text-white rounded-lg font-bold flex items-center justify-center text-[11px] sm:text-sm px-2 hover:bg-[#088a88] transition-all shadow-sm active:scale-95"
  >
    Contact for Quote
  </Link>

  {/* 2. Availability Box */}
  <div className="bg-green-50 p-1.5 sm:p-2 rounded border border-green-100 flex flex-col justify-center">
    <h5 className="text-[10px] sm:text-xs text-green-700 font-semibold uppercase tracking-tight">
      Availability
    </h5>
    <p className="text-[11px] sm:text-sm font-medium text-green-800 leading-tight">
      {product.availability}
    </p>
  </div>
</div>

              <div className="flex gap-2 sm:gap-3">
                <button
                  onClick={() => navigate(-1)}
                  className="inline-block px-3 sm:px-5 py-2 sm:py-3 bg-gray-100 rounded font-medium text-sm sm:text-base">
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 sm:mt-8">
          {/* <RelatedGrid
            items={all}
            currentId={product.id}
            categoryKey={category}
          /> */}
          {/* <RelatedGrid
  items={all}
  currentId={product.id}
  categoryKey={category}
  currentProduct={product} 
/> */}
<RelatedGrid
  items={all}
  currentId={product.id}
  categoryKey={category}
  currentProduct={product} 
/>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
